import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { usePathname } from 'next/navigation'
import { isCasinoRoute } from '@/utils/casinoTheme.mjs';
import { calendarPalette as palette } from '@/components/calendar-stuff/CalendarPalette';


const MainDiv = styled.div`
  position: fixed;
  top: 0;
  left: .0rem;
  width: 50px;
  z-index: 300;
  cursor: pointer;
  transform: scale(.55);
 
 &:before,
  &:after,
  div {
    background: ${props => props.theme.calendarCasino && props.menuactive === 'true' ? palette.onDark : props.$calendar ? palette.ink : '#000000'};
    content: "";
    display: block;
    height: 6px;
    border-radius: 3px;
    margin: 7px 0;
    transition: 0.5s;
  }

  /* Apply styles when menuActive is true */
  ${props =>
    props.menuactive === 'true' &&
    `
    &:before {
      transform: translateY(12px) rotate(135deg);
    }
    &:after {
      transform: translateY(-12px) rotate(-135deg);
    }
    div {
      transform: scale(0);
    }
  `}
`;

function HamburgerIcon({ menuActive, setMenuActive }) {
    const pathname = usePathname();
    const isCalendar = isCasinoRoute(pathname);
  
    // Function to toggle menuActive state when the icon is clicked
    const handleIconClick = () => {
      setMenuActive(!menuActive);
    };
  
    return (
      <MainDiv className="center" $calendar={isCalendar} menuactive={menuActive ? 'true' : 'false'} onClick={handleIconClick}>
        <div></div>
      </MainDiv>
    );
  }
  

export default HamburgerIcon
